import React, { useState, useEffect } from 'react';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import { NoHeaderTableUpdate } from '../../Helpers/requests';

import { GetAuth } from '../../Auth/AuthProvider';

// -- MUI -- //
import Card from '@mui/material/Card';

// -- CSS -- //
import './Control.css';

// -- COMPONENTS -- //
// import Logo from '../shared/Logo';
import ControlTicket from './ControlTicket';
import ControlMesage from './ControlMessage';
import { useNavigate } from 'react-router-dom';
import MultiClick from '../shared/MultiClick';
import TicketByTypeList from './TicketByTypeList';

import { Grid } from '@mui/material';
import { Box } from '@mui/material';

const message =
  "Welcome to Multilayer's Ticket Control System. Please select an option from the menu to the left or the quick-links below to begin.";

const tickets = [
  { id: 1, ticketName: 'Install Tickets', count: '35', ticketTab: 'install' },
  { id: 2, ticketName: 'Repair Tickets', count: '45', ticketTab: 'repair' },
];

function Control() {
  const navigateNew = useNavigate();

  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const [data_T, setData_T] = useState([]); //data displayed in datagrid
  const [page_T, setPage_T] = useState(0); //Active page of table - starts at 0!
  const [filter_T, setFilter_T] = useState([]); //Current applied filter modal
  const [sort_T, setSort_T] = useState([]); //Current applied sorting modal
  const [loading_T, setLoading_T] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRow_T] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize_T, setPageSize_T] = useState(20); //Number of rows to display
  const [totalRows_T, setTotalRows_T] = useState(0); //Total Number of rows in set
  const [updateData_T, setUpdateData_T] = useState(0); //Increment to force update dataset

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [repairData, setRepairData] = useState([]);
  const [installData, setInstallData] = useState([]);

  const LoadData = (data) => {
    setData_T(data);
    setRepairData(data?.repair_statuses ?? []);
    setInstallData(data?.install_statuses ?? []);
  };

  // useEffect(() => {
  //   checkInstalls(data_T).then((data) => setInstallData(data));
  //   checkRepairs(data_T).then((data) => {
  //     setRepairData(data);
  //   });
  // }, [data_T]);

  // const checkInstalls = async (arr) => {
  //   let data;
  //   if (arr['install_statuses'] === undefined) {
  //     data = [];
  //   } else {
  //     data = await arr['install_statuses'];
  //   }
  //   return data;
  // };
  // const checkRepairs = async (arr) => {
  //   let data;
  //   if (arr['repair_statuses'] === undefined) {
  //     data = { date: '' };
  //   } else {
  //     data = await arr['repair_statuses'];
  //   }
  //   return data;
  // };

  useEffect(() => {
    NoHeaderTableUpdate({
      resource: `/api/r2_noticeboard`,
      setDataFunc: LoadData,
      pageNum: page_T,
      setLoadingFunc: setLoading_T,
      pagesize: pageSize_T,
      sorting: sort_T,
      filtering: filter_T,
      showNotification: enqNotification,
      setRows: setTotalRows_T,
      logout,
    });
  }, [
    page_T,
    pageSize_T,
    sort_T,
    filter_T,
    updateData_T,
    enqNotification,
    logout,
  ]);

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Box sx={{ width: '80%', margin: '0 auto' }}>
      <Card sx={{ boxShadow: 'none', border: 'none' }}>
        <MultiClick />
        <ControlMesage controlMessage={message} />
        {/* <Card
          className='card-control-parent wrapper'
          sx={{
            minWidth: 350,
            maxWidth: 450,
            boxShadow: 'none',
            margin: '0 auto',
          }} */}
        {/* > */}
        {/* <Card sx={{ minWidth: 350, justifyContent: 'center' }}> */}
        {/* </Card> */}
      </Card>
      <Grid container columnGap={2.7} sx={{ width: '100%' }}>
        <Grid item xs={5.9}>
          <ControlTicket
            ticketName={'Install'}
            // ticketName={tickets[0].ticketName}
            ticketValue={data_T.total_installs}
            ticketPath={() => {
              navigateNew(`/ticket`, {
                replace: true,
                state: 'install',
              });
            }}
          />
          <TicketByTypeList ticketData={installData} type='Install' />
        </Grid>
        <Grid item xs={5.9}>
          <ControlTicket
            ticketName={'Repair'}
            // ticketName={tickets[1].ticketName}
            ticketValue={data_T.total_repairs}
            ticketPath={() => {
              navigateNew(`/ticket`, {
                replace: true,
                state: 'repair',
              });
            }}
          />
          <TicketByTypeList ticketData={repairData} type='Repair' />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Control;
